export const MEDICINESCHEDULELIST_DATE = 'MEDICINESCHEDULELIST_DATE';
export const MEDICINESCHEDULELIST_CLIENTID = 'MEDICINESCHEDULELIST_CLIENTID';